import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { Popover } from "antd";
import stylesInput from "../Input/index.module.less";
import stylesLess from "./index.module.less";
import { regexp } from "utils/method";
import { AppContext } from "contexts/app";
import XtInput from "components/Xt/Input";
import XtSvg from "components/Xt/Svg";

const PopoverContent = ({ value, minCount, regexpType, updateStatus }) => {
  const intl = useIntl();
  const pwdLengthGteX = intl.formatMessage(
    {
      id: "register.pwdLengthGteX",
    },
    {
      0: minCount,
    }
  );
  const pwdOneUppercase = intl.formatMessage({
    id: "register.pwdOneUppercase",
  });
  const pwdOneNumber = intl.formatMessage({ id: "register.pwdOneNumber" });
  const pwdFormatError = intl.formatMessage({ id: "register.pwdFormatError" });
  const pwdErrorTip = intl.formatMessage(
    { id: "app.pwdErrorTip" },
    { 0: minCount }
  );

  const result = React.useMemo(() => {
    const lengthGteX = value && value.length >= minCount;
    const uppercase = value && /[A-Z]/.test(value);
    const number = value && /[0-9]/.test(value);

    return {
      lengthGteX,
      uppercase,
      number,
    };
  }, [value, minCount]);
  React.useEffect(() => {
    // console.log("React.useEffect");
    if (updateStatus) {
      if (!value) {
        updateStatus({ isOK: false, errMsg: "" });
      } else {
        if (!result.lengthGteX) {
          updateStatus({ isOK: false, errMsg: pwdErrorTip });
        } else if (!result.uppercase) {
          updateStatus({ isOK: false, errMsg: pwdErrorTip });
        } else if (!result.number) {
          updateStatus({ isOK: false, errMsg: pwdErrorTip });
        } else if (regexpType && !regexp(regexpType, value)) {
          updateStatus({ isOK: false, errMsg: pwdErrorTip });
        } else {
          updateStatus({ isOK: true, errMsg: "" });
        }
      }
    }
  }, [value]);

  return (
    <div className={"iPopoverContent"}>
      <div>
        {result.lengthGteX ? <XtSvg icon={"correct"} /> : <i></i>}
        <div>{pwdLengthGteX}</div>
      </div>
      <div>
        {result.uppercase ? <XtSvg icon={"correct"} /> : <i></i>}
        <div>{pwdOneUppercase}</div>
      </div>
      <div>
        {result.number ? <XtSvg icon={"correct"} /> : <i></i>}
        <div>{pwdOneNumber}</div>
      </div>
    </div>
  );
};

export default React.forwardRef(function FormItemPassword(props, ref) {
  const [appState, appDispatch] = React.useContext(AppContext);
  const {
    isErr,
    allowSpace,
    popover = true,
    minCount = 8,
    regexpType = "loginPassword",
    autoComplete,
    updateStatus,
    value,
    disabled,
    onInput,
    onFocus,
    onBlur,
    ...rest
  } = props;

  const [state_isFocus, setState_isFocus] = React.useState(false);
  const [state_isEyeOpen, setState_isEyeOpen] = React.useState(false);

  const refInput = React.useRef();
  const anchorRef = React.useRef(null);

  const handleInput = (val) => {};
  const handleInputFocus = (e) => {
    // console.log("handleInputFocus", state);
    setState_isFocus(true);
    onFocus && onFocus(e);
  };
  const handleInputBlur = (e) => {
    // console.log("handleInputBlur", state);
    setState_isFocus(false);
    onBlur && onBlur(e);
  };
  const handleInputCopy = (e) => {
    // console.log(e.target.innerHTML);
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
  };

  const handleClear = () => {
    onInput && onInput("");
    refInput.current.focus();
  };
  const handleEyeToggle = () => {
    setState_isEyeOpen(!state_isEyeOpen);
    // refInput.current.focus();
  };

  const classList = [
    stylesInput.main,
    stylesLess.main,
    appState.isDark ? "dark" : "light",
  ];
  isErr && classList.push("err");
  state_isFocus && classList.push("atv");

  const ElMain = (
    <div className={`${classList.join(" ")}`} ref={anchorRef}>
      <XtInput
        ref={refInput}
        value={value}
        type={state_isEyeOpen ? "text" : "password"}
        autoComplete={autoComplete}
        maxLength="1000"
        disabled={disabled}
        onInput={(val) =>
          allowSpace ? onInput(val) : onInput(val.replace(/\s*/g, ""))
        }
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        onCopy={handleInputCopy}
        {...rest}
      />
      {(value || value === 0) && (
        <button
          className="btntxt ico"
          disabled={disabled}
          onClick={handleClear}
        >
          <XtSvg icon={"error"} />
        </button>
      )}
      <button
        className="btntxt ico"
        disabled={disabled}
        onClick={handleEyeToggle}
      >
        <XtSvg icon={state_isEyeOpen ? "eye-on" : "eye-off"} />
      </button>
    </div>
  );

  React.useImperativeHandle(ref, () => ({
    inputEl: refInput.current,
  }));

  return (
    <>
      {popover && (
        <Popover
          getPopupContainer={() => anchorRef.current}
          content={
            <PopoverContent
              value={value}
              minCount={minCount}
              regexpType={regexpType}
              updateStatus={updateStatus}
            />
          }
          placement="right"
          overlayClassName={"iPopover"}
          visible={state_isFocus && !!refInput.current.value}
        >
          {ElMain}
        </Popover>
      )}
      {!popover && ElMain}
    </>
  );
});
